import PosthogJS from 'posthog-js';
import { checkLocalStorage, cleanUpLocalStorage, cacheToLocalStorage } from './PostHogCache';

let postHogLoaded = false;

/**
 * Checks local storage for a cached feature flag group before fetching it from posthog.
 * @public - We are not currently running any tests so this is required to prevent unused export.
 */
export const getTestGroup = (flag:string) => {
    const cached = checkLocalStorage(flag);
    if (cached) {
        return cached;
    }
    // If we get a false feature flag, this function will return the default value 'control'
    const value = `${posthog.getFeatureFlag(flag) || 'control'}`;
    cacheToLocalStorage(flag, value);
    return value;
};

export const identify = () => {
    if (postHogLoaded && postHogAutoCapture && window.userId) {
        const { userType } = window.userObj;
        posthog.identify(`${window.userId}`, {
            ...(userType && { type: userType }),
        });
    }
};

export const clearIdentity = () => {
    if (postHogLoaded && postHogAutoCapture) {
        posthog.reset();
    }
};

const setup = () => {
    cleanUpLocalStorage();
    identify();
};

// We init posthog as a global side-effect. This allows use to add event capturing to non-react based pages in the future
export const posthog = PosthogJS.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-01-30',
    capture_pageleave: false,
    loaded: () => {
        postHogLoaded = true;
        setTimeout(setup, 5);
    },
});
